import Link from '../Link';
import React from 'react';
import VerticalCenter from '../VerticalCenter';
import styles from './ButtonLink.module.scss';

export default class ButtonLink extends React.Component {
    render() {
        var classes = ['buttonlink', this.props.className, styles.ButtonLink],
            style = Object.assign({}, this.props.style);

        if (this.props.href) {
            return (
                <Link
                    className={classes.join(' ')}
                    href={this.props.href}
                    onClick={this.handleClick.bind(this)}
                    style={style}
                    disabled={this.props.disabled}>
                    {this.props.children}
                </Link>
            );
        } else if (this.props.type == 'submit') {
            return (
                <button
                    type='submit'
                    className={classes.join(' ')}
                    onClick={this.handleClick.bind(this)}
                    style={style}
                    disabled={this.props.disabled}>
                    {this.props.children}
                </button>
            );
        } else {
            return (
                <button
                    type='button'
                    className={classes.join(' ')}
                    onClick={this.handleClick.bind(this)}
                    style={style}
                    disabled={this.props.disabled}>
                    {this.props.children}
                </button>
            );
        }
    }
    handleClick(e) {
        this.props.onClick && this.props.onClick(e);
    }
}
